/* unplugin-vue-components disabled */import { render } from "./close-modal.vue?vue&type=template&id=04e05a28&scoped=true"
import script from "./close-modal.vue?vue&type=script&lang=js"
export * from "./close-modal.vue?vue&type=script&lang=js"

import "./close-modal.vue?vue&type=style&index=0&id=04e05a28&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e05a28"],['__file',"src/pages/onboarding/close-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e05a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e05a28', __exports__)) {
    api.reload('04e05a28', __exports__)
  }
  
  module.hot.accept("./close-modal.vue?vue&type=template&id=04e05a28&scoped=true", () => {
    api.rerender('04e05a28', render)
  })

}


export default __exports__